import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import { api, ApiError } from "../api";
import { consumeState, setAppToken } from "../auth";
import { useT } from "../i18n";

export function CallbackPage() {
  const navigate = useNavigate();
  const t = useT();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    const code = params.get("code");
    const returnedState = params.get("state");
    const expectedState = consumeState();

    if (!code) {
      setError("Missing authorization code");
      return;
    }
    if (!expectedState || returnedState !== expectedState) {
      setError("Invalid state parameter (possible CSRF)");
      return;
    }

    api
      .exchangeEveCode(code)
      .then((response) => {
        setAppToken(response.app_token);
        navigate("/", { replace: true });
      })
      .catch((err) => {
        const message =
          err instanceof ApiError
            ? typeof err.detail === "string"
              ? err.detail
              : JSON.stringify(err.detail)
            : (err as Error).message;
        setError(message);
      });
  }, [params, navigate]);

  return (
    <div className="page">
      <div className="login-card">
        <h1>{t.authenticating}</h1>
        {error && (
          <>
            <p className="error">{t.authFailed}: {error}</p>
            <Link to="/login">{t.backToLogin}</Link>
          </>
        )}
      </div>
    </div>
  );
}
